var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initHotspotSlider = /* @__PURE__ */ __name(($el) => {
  const state = window.Alpine.reactive({
    element: $el
  });
  const renderHotspotContent = /* @__PURE__ */ __name(async (el) => {
    const hotspotItems = document.querySelectorAll("[data-hotspot-item]");
    el.innerHTML = "";
    document.querySelectorAll("[data-tab-id]:has([data-hotspot-item])")?.forEach((tab) => {
      const style = window.getComputedStyle(tab);
      if (style.display === "none") {
        tab.querySelectorAll("[data-hotspot-item]")?.forEach((el2) => el2.setAttribute("data-tab-visible", "false"));
      } else {
        tab.querySelectorAll("[data-hotspot-item]")?.forEach((el2) => el2.setAttribute("data-tab-visible", "true"));
      }
    });
    hotspotItems?.forEach((item, index) => {
      if (!item.hasAttribute("data-intersected")) {
        item.setAttribute("data-intersected", "true");
      }
      const card = item.querySelector("[data-style-hotspot-card")?.cloneNode(true);
      card.classList.toggle("!hidden", item.dataset.tabVisible === "false");
      el.appendChild(card);
    });
  }, "renderHotspotContent");
  const handleScroll = /* @__PURE__ */ __name((activeIndex) => {
    document.querySelectorAll("[data-hotspot-active]").forEach((el) => {
      el.setAttribute("data-hotspot-active", "false");
      el.dispatchEvent(new CustomEvent("hotspot-update", { bubbles: true }));
    });
    const activeElement = document.querySelector(
      `[data-tab-visible="true"][data-hotspot-item="${activeIndex}"]`
    );
    if (activeElement) {
      activeElement.setAttribute("data-hotspot-active", "true");
      activeElement.dispatchEvent(new CustomEvent("hotspot-update", { bubbles: true }));
    }
  }, "handleScroll");
  return new Promise((resolve) => {
    renderHotspotContent($el).then(() => {
      resolve({
        state,
        renderHotspotContent,
        handleScroll
      });
    });
  });
}, "initHotspotSlider");
window._sections["initHotspotSlider"] = initHotspotSlider;
